import { render, staticRenderFns } from "./LandingShop.vue?vue&type=template&id=18310eb4&scoped=true&"
import script from "./LandingShop.vue?vue&type=script&lang=js&"
export * from "./LandingShop.vue?vue&type=script&lang=js&"
import style0 from "./LandingShop.vue?vue&type=style&index=0&id=18310eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18310eb4",
  null
  
)

export default component.exports